import { statsGateway } from "@/gateways/statsGateway";
import { useQuery } from "@tanstack/vue-query";

export function useGetPublicStats() {
  const query = useQuery({
    queryKey: ["stats", "public"],
    queryFn: () => statsGateway.getPublicStats(),
  });

  return { ...query, getStatsStatus: query.status, stats: query.data };
}
